import { Button } from "@mui/material";
import React, { Fragment, useContext } from "react";

import { UpsellPackage, UpsellPackagedProduct } from "../../../logic/api";
import styles from "./styles";
import flex from "../../../styles/flex";
import { SessionContext } from "../../../utility/useSession";
import { getUpsellProductPrice, getUpsellProductPriceFormatted } from "../builder/UpsellsBuilder";
import { useTranslation } from "react-i18next";


const UpsellSelectorListItem: React.FunctionComponent<{
    upsellPackage: UpsellPackage,
    onSelect: (pkg: UpsellPackage, product: UpsellPackagedProduct) => void,

}> = (props) => {
    const pkg = props.upsellPackage;
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const products = pkg.products;


    products.sort((a, b) => getUpsellProductPrice(b) - getUpsellProductPrice(a));

    return <Fragment>
        <div style={{ ...styles.listItem, marginBottom: 20, }}>
            <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>


                <div style={{ ...flex.flexFill, textAlign: "left" }}>
                    <div>
                        <b style={{ "color": "blue", fontSize: 18 }}>{pkg.name}</b>
                    </div>
                    <div style={{ paddingBottom: 10 }}>
                        <b>{pkg.advertText}</b>
                    </div>
                </div>


            </div>
            {products.map((packagedProduct, i) => {

                if (packagedProduct.topLevel != true) {
                    return <div key={i}></div>;
                }

                const subProducts = products.filter((p) => p.parentRef == packagedProduct.ref && p.topLevel == false);


                return <div key={i} style={{ paddingBottom: 5 }} data-testid={`upsell-selector-list-item-${pkg.id}-${packagedProduct.ref}`}>

                    <Button

                        onClick={() => props.onSelect(pkg, packagedProduct)}

                        style={{ width: "100%", minWidth: 250 }} variant="contained" color="primary">
                        <div style={{ width: "100%" }}>
                            <div style={flex.flexRows}>
                                {packagedProduct.qty > 1 && (<div style={flex.flexAuto}><b style={{ marginRight: 7 }}>{packagedProduct.qty} x</b></div>)}
                                <div style={flex.flexAuto}> <b style={{ fontSize: 16, marginRight: 10 }}>{packagedProduct.alias ?? packagedProduct.product.name} </b></div>
                                <div style={flex.flexFill}></div>
                                <div style={flex.flexAuto}><b>{getUpsellProductPriceFormatted(packagedProduct, products, session)}</b></div>
                            </div>
                            {subProducts.length > 0 && (
                                <div style={{ textAlign: "left" }}>
                                    {[packagedProduct, ...subProducts,].map((sp, s) => {
                                        return <div key={s} style={{ marginLeft: 20 }}>
                                            <div style={flex.flexRows}>

                                                <div style={flex.flexFill}>  {s == 0 && (<i>{t("upsells.packageIncludes")}:</i>)} </div>

                                                <div style={flex.flexAuto}><div style={{ width: 200 }}><b>+ {sp.product.name} {`${sp.qty > 1 ? `(x${sp.qty})` : ""}`}</b></div></div>

                                            </div>
                                        </div>;
                                    })}
                                </div>
                            )}
                        </div>


                    </Button>
                </div>;

            })}
        </div >
    </Fragment>
}

export default UpsellSelectorListItem;